import React, { Fragment } from 'react';
import PropTypes from "prop-types";

export default class AsyncDataProvider extends React.Component {
    /**
     * id - identifier used for in state key value store
     * obj - the object with async data
     * field - async data field that needs to be fetched
     * data - Object
     *    fetchData - Function callback used to make the async data call
     *    fields - Async data fields that are recieved in fetch call that need merging back to object
     */
    static prodTypes = {
        id: PropTypes.string.required,
        obj: PropTypes.object.required,
        data: PropTypes.arrayOf(
                PropTypes.shape({
                  fetchData: PropTypes.number.isRequired,
                  fields: PropTypes.array.isRequired
                })
            ).isRequired,
    };

    state = {
        objMap: {}
    }

    componentDidMount(){
        this.setObjMap();
    }

    componentDidUpdate(prevProps){
        const { id } = this.props;
       if(id !== prevProps.id
            && !this.state.objMap.hasOwnProperty(id)){
            this.setObjMap();
        }
    }

    setObjMap = () => {
        const { obj, id, data } = this.props;
        let asyncPromise = [];

        //loop through data and fields to check for existence
        //if doest not exist add to asyncPromies
        asyncPromise = data.map((asyncData, index) => {
            const hasAllData = asyncData.fields.reduce((result, field) => {
                const fieldType = typeof obj[field];
                //document already includes field skip api call
                if(!id || obj[field] && (fieldType !== 'object' || Object.keys(obj[field]).length > 1)){
                    return result && true;
                }
                return false
            }, true)

            //document already includes field skip api call
            if(hasAllData){
                return;
            }else{
                return asyncData.fetchData(id, obj)
            }
        });

        Promise.all(asyncPromise).then((asyncResp) => {
            let objMap = {...this.state.objMap};
            let hasData = false;

            //promise reponse should map back to data array
            const objData = asyncResp.reduce((result, resp, index) => {
                if(!resp){
                    return result;
                }
                hasData = true;
                //pluck fields from response
                return {
                    ...result,
                    ...data[index].fields.reduce((r,f) => {
                        if(resp[f]){
                            r[f] = resp[f];
                        }
                        return r;
                    },{})
                };

            },{});

            if(hasData){
                 objMap[id] = objData;
                 this.setState({objMap});
            }
        })

    }

    render(){
        const { obj, children, id } = this.props;
        const { objMap } = this.state;
        // const objWithAsyncData = objMap[id] ? Object.assign({}, obj, objMap[id]) : obj;
        const objWithAsyncData = objMap[id] ? { asyncDataLoaded: true, ...obj, ...objMap[id] } : { asyncDataLoaded: false, ...obj };
        return(children(objWithAsyncData));
    }
}
